import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
  SkeletonTextBlock,
} from '@/components/common/skeleton';
import { REDESIGN_SPACING } from '@/constants/residents/homeConstants';

export const DesktopEventsScreenSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    {/* Page header placeholder */}
    <SkeletonBone width={120} height={28} />

    {/* Event cards */}
    {Array.from({ length: 3 }).map((_, i) => (
      <View key={i} style={styles.cardWrapper}>
        <SkeletonCard padding={0} borderRadius={16}>
          <View style={styles.cardRow}>
            {/* Event image */}
            <View style={styles.imageWrapper}>
              <SkeletonBone width={220} height={180} borderRadius={12} />
            </View>
            {/* Event content */}
            <View style={styles.cardContent}>
              <SkeletonBone width={80} height={24} borderRadius={999} />
              <SkeletonBone width="70%" height={20} />
              <View style={styles.metaRow}>
                <SkeletonBone width={100} height={14} />
                <SkeletonBone width={100} height={14} />
              </View>
              <View style={styles.metaRow}>
                <SkeletonBone width={90} height={14} />
                <SkeletonBone width={80} height={14} />
              </View>
              <SkeletonTextBlock lines={2} lineHeight={14} lastLineWidth="60%" />
            </View>
          </View>
        </SkeletonCard>
      </View>
    ))}
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    padding: REDESIGN_SPACING.horizontalPadding,
    paddingBottom: 40,
    gap: 16,
  },
  cardWrapper: {
    width: '100%',
    maxWidth: 1100,
    alignSelf: 'center',
  },
  cardRow: {
    flexDirection: 'row',
  },
  imageWrapper: {
    padding: 8,
  },
  cardContent: {
    flex: 1,
    padding: 16,
    gap: 6,
  },
  metaRow: {
    flexDirection: 'row',
    gap: 12,
  },
});
